import { useState } from 'react';
import { Link } from 'react-router-dom';
import { z } from 'zod';
import { Field } from '@/components/form/field';
import { FormError } from '@/components/form/form-error';
import { useZodForm } from '@/components/form/use-zod-form';
import { requiredEmail } from '@/lib/schemas';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { forgotPassword } from '../api/auth';
import { AuthCard } from '../components/auth-card';

const schema = z.object({
  email: requiredEmail,
});

export function ForgotPasswordPage() {
  const form = useZodForm(schema, { email: '' });
  const [sent, setSent] = useState(false);
  const [serverError, setServerError] = useState<unknown>(null);

  const onSubmit = form.handleSubmit(async ({ email }) => {
    setServerError(null);
    try {
      await forgotPassword(email);
      setSent(true);
    } catch (caught) {
      setServerError(caught);
    }
  });

  return (
    <AuthCard
      title="Esqueci minha senha"
      description="Enviaremos um link para criar uma nova senha."
    >
      {sent ? (
        // A mesma mensagem exista ou não a conta: a tela não pode confirmar quem está cadastrado.
        <p className="text-sm">
          Se houver uma conta com este e-mail, o link chega em alguns minutos. Ele vale por 30
          minutos.
        </p>
      ) : (
        <form onSubmit={onSubmit} className="space-y-4" noValidate>
          <FormError error={serverError} fallback="Não foi possível enviar o link." />
          <Field control={form.control} name="email" label="E-mail" required>
            {(field) => <Input {...field} type="email" autoComplete="username" />}
          </Field>
          <Button type="submit" className="w-full" disabled={form.formState.isSubmitting}>
            {form.formState.isSubmitting ? 'Enviando…' : 'Enviar link'}
          </Button>
        </form>
      )}
      <Link
        to="/entrar"
        className="mt-4 block text-center text-sm text-muted-foreground hover:text-foreground"
      >
        Voltar para o login
      </Link>
    </AuthCard>
  );
}
